import React, { useEffect } from "react";
import "./index.scss";
import CartItem from "../cart/CartItem";
import sort from "../../assets/images/marketplace/sort.png";
import { useState } from "react";
import StatusModal from "../statusModal/StatusModal";
import { useNavigate, useParams } from "react-router-dom";
import { getStorageItem } from "../../utils/sessionStorage";
import axios from "axios";
export default function OrderStatus() {
  const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const [whichopen, setwhichopen] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userId = getStorageItem("user_id");
  const userEmail = getStorageItem("user_email");
  const navigate = useNavigate();

  // Access Token
  const accessToken = getStorageItem("token");
  // const [statusModal, setStatusModal] = useState(false);
  const handleOrder = () => {
    setwhichopen(!whichopen);
  };

  const handleSortClick = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Function to fetch product
  const fetchProduct = async (info) => {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
        `/marketplace/product/getSingleProductByProductId/${info?.productId}`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const product = await response.json();
      const sellerDetails = await handleCheckSeller(product);
      return {
        productInfo: product,
        sellerInfo: sellerDetails,
        orderInfo: info,
      };
    } catch (err) {
      console.log(err);
    }
  };

  // Function to fetch seller details
  const handleCheckSeller = async (product) => {
    if (!product?.sellerId && !accessToken) return
    const opt = {
      method: "GET",
      url:
        global.config.ROOTURL.prod +
        `/marketplace/seller/findInformationOfSingleSellerById/${product?.sellerId}`,
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios(opt);
      const sellerInfo = response?.data;
      return sellerInfo;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const { id } = useParams();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [sellerOrders, setSellerOrders] = useState([]);
  const fetchOrders = async () => {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
        `/marketplace/buyer/allPurchasedProducts/${id}`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      const productPromises = data.map(async (info) => {
        const obj = await fetchProduct(info);
        return obj;
      });

      // Wait for all promises to resolve
      const resolvedProducts = await Promise.all(productPromises);

      setOrders(resolvedProducts);
      setFilteredOrders(resolvedProducts);
    } catch (err) {
      console.log(err.message);
    }
  };
  const [filteredProductsTypes, setFilteredProductsTypes] = useState("all");
  const handleGetAllMyOrders = async () => {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
        `/marketplace/buyer/allPurchasedProducts/${id}`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      const productPromises = data.map(async (info) => {
        const obj = await fetchProduct(info);
        return obj;
      });
      // Wait for all promises to resolve
      const resolvedProducts = await Promise.all(productPromises);
      setOrders(resolvedProducts);
      setFilteredOrders(resolvedProducts);
    } catch (err) {
      console.log(err.message);
    }
  }
  useEffect(() => {
    if (filteredProductsTypes === "all") {
      setFilteredOrders(orders);
    }
    else {
      const newProducts = orders.filter((order) => {
        return order?.orderInfo?.currentState === filteredProductsTypes;
      });
      setFilteredOrders(newProducts);
    }
  }, [filteredProductsTypes, orders]);
  useEffect(() => {
    fetchOrders(id);
  }, [id]);
  useEffect(() => {
    handleGetAllMyOrders();
  }, [id]);
  return (
    <div className="MainOrderStatus-1">
      <div className="filterContainer-1">
        <p>Orders</p>
        <img src={sort} alt="Sort Icon" onClick={handleSortClick} />
      </div>
      <div className="bodyofOrderStatus-1">
        <div className="firstContainer-1">
          <div className="orderButton1-1">
            <p
              className={whichopen ? "higlited-1" : "nothiglited-1"}
              onClick={handleOrder}
            >
              Order Placed
            </p>
          </div>
          <hr style={{ height: "40px" }} />
          <div className="orderButton1-1">
            <p
              className={!whichopen ? "higlited-1" : "nothiglited-1"}
              onClick={() => {
                handleOrder();
                navigate("/marketplace/seller_orders");
              }}
            >
              Order Recieved
            </p>
          </div>
        </div>
        {filteredOrders.length > 0 ? (
          <div className="SecoundContainer-1">
            {filteredOrders?.map((order) => (
              <CartItem key={order?._id} isOrder={true} product={order} isCart={false} />
            ))}
          </div>
        ) : (
          <div className="empty-orders-1">
            <div>
              <h1 className="eo-heading-1">Nothing to show here</h1>
              <button
                className="eo-button-1"
                onClick={() => {
                  navigate("/marketplace");
                }}
              >
                Go back to marketplace
              </button>
            </div>
          </div>
        )}
      </div>

      {isModalOpen && (
        <StatusModal
          open={isModalOpen}
          handleClose={() => setIsModalOpen(false)}
          setFilteredProductsTypes={setFilteredProductsTypes}
        />
      )}
    </div>
  );
}
